"use strict";

import Widgets from 'js-widget-hooks';
import './widgets/dropdown'
import './widgets/show-more';
import './widgets/map';

// https://webpack.js.org/guides/public-path/
// because our wordpress is probably installed wherever, we
// noinspection JSUnresolvedVariable
__webpack_public_path__ = GLOBAL_CONFIG.config.asset_root;

// the actual Wiget execution is triggered here
window.onload = function () {

    Widgets.init(null, {
        widgetClass: 'js-widget'
    });

};